export var OPEN_INACTIVITY_MODALS = 'openAllModals';
export var CLOSE_INACTIVITY_MODALS = 'closeAllModals';
export var CLOSE_INACTIVITY_MODALS_AFTER_LOGOUT = 'closeModalsAfterLogout';
